import React from 'react';
import { useFormContext } from 'react-hook-form';
import { keyType, StackPanel, Typography } from '@agilepoint/wat-react-ux';
import { Localize, useTranslate } from '@agilepoint/wat-react';
import { AppListOptionsWrapper, AppSelecionWrapper, StyledListView, StyledRadioGroupField, AppSelectionHeaderWrapper, StyledCheckboxField } from '../styled-components';
import { IAppMetadata } from '../steps';


interface IAppFiltersForm {
    appMetadata: IAppMetadata[];
}

export const AppFiltersForm = React.memo((props: IAppFiltersForm) => {
    const translate = useTranslate();
    const { appMetadata } = props;
    const options = [
        {
            name: translate('modules.createNewApp.steps.appFilters.displayAllValueTitle'),
            value: 'Show all of my AgilePoint NX Apps in the custom mobile app',
            title: translate('modules.createNewApp.steps.appFilters.displayAllValueTitle'),
            key: 'show-all'
        },
        {
            name: translate('modules.createNewApp.steps.appFilters.displaySelectedValueTitle'),
            value: 'Show only the AgilePoint NX Apps selected below',
            title: translate('modules.createNewApp.steps.appFilters.displaySelectedValueTitle'),
            key: 'show-only-selected-below'
        }];

    const { setValue } = useFormContext();

    const onRenderItem = (itemProps: IAppMetadata) => <AppSelectionRow {...itemProps} />;

    const onValueChange = React.useCallback((selectedKey: keyType) => {
        if (selectedKey === 'show-all') {
            return appMetadata.forEach((item) => setValue(`showApps.${item.name}`, true));
        }
        appMetadata.forEach((item) => setValue(`showApps.${item.name}`, false));
    }, [appMetadata, setValue]);

    return (
        <StackPanel gap="20" orientation='vertical' width="660px" height="calc(100% - 70px)">
            <AppListOptionsWrapper>
                <StyledRadioGroupField
                    groupName="app-list-options"
                    options={options}
                    onValueChange={onValueChange}
                    name="appListOptions" />
            </AppListOptionsWrapper>
            <AppSelecionWrapper flexDirection='column' height="calc(100% - 125px)" width="100%" maxHeight="620px">
                <AppSelectionHeaderWrapper height='40px' gap="50" alignment="center">
                    <Typography.Small title={translate('modules.createNewApp.steps.appFilters.showLabel')}><Localize translate='modules.createNewApp.steps.appFilters.showLabel' /></Typography.Small>
                    <Typography.Small title={translate('modules.createNewApp.steps.appFilters.nxAppLabel')}><Localize translate='modules.createNewApp.steps.appFilters.nxAppLabel' /></Typography.Small>
                </AppSelectionHeaderWrapper>
                <StyledListView
                    items={appMetadata}
                    onRenderItemContent={onRenderItem}
                    isVirtualized
                    allowKeyboardNavigation
                    itemHeight={44}
                    getKey={(item: IAppMetadata) => item.appID} />
            </AppSelecionWrapper>
        </StackPanel>
    );
});

const AppSelectionRow = React.memo((props: IAppMetadata) => {
    const { watch } = useFormContext();
    const appListOptions = watch('appListOptions');
    const { name } = props;

    return (
        <StackPanel height='100%' gap="73" width="100%" alignment="center">
            <StyledCheckboxField name={`showApps.${name}`} disabled={appListOptions === 'show-all'} />
            <Typography.Medium title={name}>{name}</Typography.Medium>
        </StackPanel>
    );
});
